export function preventPaddleRetainDuplication() {
  // check flag in localstorage for it
  const isRetainShown = localStorage.getItem('retain_shown');
  const now = Date.now();
  const newExpiration = now + 1000 * 60 * 60;

  // if flag is not exist, set flag and persist it into localstorage
  if (!isRetainShown) {
    localStorage.setItem('retain_shown', newExpiration.toString());
  } else {
    const exp = parseInt(isRetainShown, 10);

    // if exist and not expired, remove it from url
    if (exp > now) {
      window.location.href = window.location.pathname + window.location.hash;
    } else {
      localStorage.setItem('retain_shown', newExpiration.toString());
    }
  }
}

export function isExistOnQuery(key: string) {
  return window.location.search.includes(key);
}
